export const GET_REPORTS_PENDING = "GET_REPORTS_PENDING"
export const GET_REPORTS_SUCCESS = "GET_REPORTS_SUCCESS"
export const GET_REPORTS_FAILURE = "GET_REPORTS_FAILURE"

export const DOWNLOAD_REPORTS_PENDING = "DOWNLOAD_REPORTS_PENDING"
export const DOWNLOAD_REPORTS_SUCCESS = "DOWNLOAD_REPORTS_SUCCESS"
export const DOWNLOAD_REPORTS_FAILURE = "DOWNLOAD_REPORTS_FAILURE"